__turbopack_context__.v({
  "account-menu-item": "UserMenu-module-scss-module__f-YSAW__account-menu-item",
  "menu-button": "UserMenu-module-scss-module__f-YSAW__menu-button",
  "menu-item-wrapper": "UserMenu-module-scss-module__f-YSAW__menu-item-wrapper",
  "menu-link": "UserMenu-module-scss-module__f-YSAW__menu-link",
  "popup": "UserMenu-module-scss-module__f-YSAW__popup",
  "settings-link": "UserMenu-module-scss-module__f-YSAW__settings-link",
  "trigger": "UserMenu-module-scss-module__f-YSAW__trigger",
  "user-email": "UserMenu-module-scss-module__f-YSAW__user-email",
  "wrapper": "UserMenu-module-scss-module__f-YSAW__wrapper",
});
